const previewDateFormatter = new Intl.DateTimeFormat("de-DE", {
  timeZone: "Europe/Berlin",
  day: "2-digit",
  month: "2-digit",
})
const previewTimeFormatter = new Intl.DateTimeFormat("de-DE", {
  timeZone: "Europe/Berlin",
  hour: "2-digit",
  minute: "2-digit",
})

/** Preview times describe eligibility, never a completed send or guaranteed delivery. */
export const formatPreviewDueAt = (value?: string | null): string | null => {
  if (!value) return null

  const parsed = new Date(value)

  if (Number.isNaN(parsed.getTime())) return null

  const date = previewDateFormatter.format(parsed)
  const time = previewTimeFormatter.format(parsed)

  return `${date}, ${time} Uhr`
}

export const buildAnnouncementTimingPresentation = ({
  label,
  action = "geplant ab",
  active,
  pending,
  planned,
  dueAt,
  previewError,
  reasonCode,
}: {
  label: string
  action?: "geplant ab" | "automatisch beauftragen ab" | "Inbox-Aufgabe ab"
  active: boolean
  pending: boolean
  planned: boolean
  dueAt?: string | null
  previewError?: string | null
  reasonCode?: string | null
}): { topLabel: string; color: "blue" | "neutral" | "amber" | "red" } => {
  if (!active) return { topLabel: `${label} · Nicht eingeplant`, color: "neutral" }

  if (pending) return { topLabel: `${label} · Zeitpunkt wird berechnet`, color: "blue" }

  if (previewError) return { topLabel: `${label} · Vorschau nicht verfügbar`, color: "red" }

  if (!planned) {
    const detail =
      reasonCode === "skipped_after_deadline"
        ? "Vor dem Termin nicht mehr möglich"
        : "Ausgewählt, aber nicht eingeplant"

    return { topLabel: `${label} · ${detail}`, color: "amber" }
  }

  const time = formatPreviewDueAt(dueAt)

  return time
    ? { topLabel: `${label} · ${action} ${time}`, color: "blue" }
    : { topLabel: `${label} · Zeitpunkt nicht verfügbar`, color: "amber" }
}
